export const borderRadius = {
    s: '8px',
    s2: '0px 8px 8px 8px',
    l: '30px',
    circle: '50%',
};
export const shadow = {
    none: 'none',
    s: '0px 1px 6px rgba(0,0,102, 0.16)',
    m: '0px 3px 6px rgba(0, 0, 102, 0.16)',
    l: '0px -3px 6px rgba(0, 0, 102, 0.16)',
    xl: '0px 8px 24px rgba(0, 0, 102, 0.16)',
};
export const spacing = {
    xxs: '0.3125rem', // 5px
    xs: '0.625rem', // 10px
    s: '0.9375rem', // 15px
    m: '1.25rem', // 20px
    l: '1.5625rem', // 25px
    xl: '1.875rem', // 30px
    xxl: '2.5rem', // 40px
    '3xl': '3.125rem', // 50px
    '4xl': '3.75rem', // 60px
    '5xl': '4.0625rem', // 65px
    '6xl': '5.9375rem', // 95px
    '7xl': '6.875rem', // 110px
};
